// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"CompanyCommitteeList_listContainer__QSosc"};